import CatalogsLayout from "Components/CatalogsLayout";
import Grid, { SelectColumnFilter, TextFilter } from "Components/Grid";
import Layout from 'Layout'
import React, { CSSProperties, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';
import Buttons from "Components/Buttons";
import { IBrand } from "Interfaces/IBrand";
import CatalogsModal from "Components/CatalogsModal";
import Modal from "Components/V1/Modal";
import ServiceArchivo from "service/archivos";
import EditArchivo from "Components/V1/ModalComponents/Archivo/Edit";
import ConfiguracionMT from "Components/V1/ModalComponents/Archivo/ConfiguracionMT";
import CreateRelUserFiles from "Components/V1/ModalComponents/RelUsuariosArchivos/Create";
import UpdateRelUserFiles from "Components/V1/ModalComponents/RelUsuariosArchivos/Update";

const typeModal: any = Object.freeze({
  NEW: "NEW",
  EDIT: "EDIT",
  CONFMT: "CONFMT",
});

// @ts-nocheck
const RelUsuariosArchivos = () => {
  const { catalogs } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);



  const [data, setData] = useState([])
  const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [errors, setErrors] = useState<IBrand>({});
  const [formValues, setFormValues] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);




  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [componentActual, setComponentActual] = useState<string>('');
  const [selected, setSelected] = useState<any>();

  useEffect(() => {
    getAll();

  }, [])

  const getAll = () => {
    ServiceArchivo.getRelUsuariosArchivos(setData)
  }
  const handleNew = () => {
    setComponentActual(typeModal.NEW);
    setTitle("Relación Usuarios - Archivos");
    handleChange(true)();
  };
  const handleEdit = (row:any) => {
    setComponentActual(typeModal.EDIT);
    setSelected(row);
    setTitle("Relación Usuarios - Archivos");
    handleChange(true)();
  };
  const handleConfMT = (row:any) => {
    setComponentActual(typeModal.CONFMT);
    setSelected(row);
    setTitle("Configurar Marcas y Tipo de Operación");
    handleChange(true)();
  };
  const handleChange = (option: boolean = false) => (e?: any) => { setOpen(option) };
  






  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  const handleAdd = () => {
    setAction("add");
    setErrors({});
    /* setFormValues(defaultItem); */
    setOpen(true);
  }

  const columns = [
    {
      accessor: "idUsuario",
      Header: "ID",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "nombre",
      Header: "Nombre de Usuario",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "correo",
      Header: "Correo",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "estatus",
      Header: "Estatus",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
  ];
  const config: any = {
    actions: [
      {
        action: "editArchivos",
        tooltip: "Editar Permisos",
        visible: true,
        handle: handleEdit,
        color: "#ffb300",
        icon: "edit",
      },
    ],
  };

  return (
    <Layout theme={styles}>
      <>
        <CatalogsLayout bannerTitle={'Relación Usuarios - Archivos'}>
          <Grid columns={columns} data={data} config={config} isLoading={isLoadingGrid}>
            <Buttons
              title={"Actualizar"}
              type={"add-catalog"}
              config={btnSimple}
              handleClick={getAll}
            />
            <Buttons
              title={"Agregar"}
              type={"add-catalog"}
              config={btnSimple}
              handleClick={handleNew}
            />
          </Grid>
          <Modal
            title={title}
            open={open}
            handleChange={handleChange}
            loader={loading}
            size="60vw"
          >
            {componentActual === typeModal.NEW && (
              <CreateRelUserFiles
                reloadData={getAll}
                closeModal={() => {
                  setComponentActual("");
                  setOpen(false);
                }}
                loading={loading}
                setLoading={setLoading}
              />
            )}
            {componentActual === typeModal.EDIT && (
              <UpdateRelUserFiles
                reloadData={getAll}
                closeModal={() => {
                  setComponentActual("");
                  setOpen(false);
                }}
                loading={loading}
                setLoading={setLoading}
                row={selected}
              />
            )}
            {componentActual === typeModal.CONFMT && (
              <ConfiguracionMT
                reloadData={getAll}
                closeModal={() => {
                  setComponentActual("");
                  setOpen(false);
                }}
                loading={loading}
                setLoading={setLoading}
                row={selected}
              />
            )}



          </Modal>
        </CatalogsLayout>
      </>
    </Layout>
  )
}

export default RelUsuariosArchivos